const REGULAR_CLASS_ID = 1;
const BENEFIT_CLASS_ID = 2;

const toSafeInt = value => {
  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : 0;
};

const buildZoneName = zoneId => `Зона ${zoneId}`;

export const mapParkingLotsToZones = (lots = []) => {
  const grouped = new Map();

  (lots || []).forEach(lot => {
    const zoneId = lot?.zone_id;

    if (zoneId === null || typeof zoneId === 'undefined') {
      return;
    }

    const zoneKey = String(zoneId);

    if (!grouped.has(zoneKey)) {
      grouped.set(zoneKey, {
        id: zoneKey,
        name: buildZoneName(zoneId),
        code: zoneKey,
        coordinates: [],
        regular_spaces: 0,
        regular_busy_spaces: 0,
        benefit_spaces: 0,
        benefit_busy_spaces: 0,
      });
    }

    const zone = grouped.get(zoneKey);
    const classId = toSafeInt(lot?.class_id);
    const maxParkingLots = toSafeInt(lot?.max_parking_lots);
    const occupiedLots = toSafeInt(lot?.occupied_lots);

    if (classId === BENEFIT_CLASS_ID) {
      zone.benefit_spaces = maxParkingLots;
      zone.benefit_busy_spaces = occupiedLots;

      return;
    }

    if (classId === REGULAR_CLASS_ID) {
      zone.regular_spaces = maxParkingLots;
      zone.regular_busy_spaces = occupiedLots;

      return;
    }

    // Fallback for unknown class_id values.
    zone.regular_spaces += maxParkingLots;
    zone.regular_busy_spaces += occupiedLots;
  });

  return Array.from(grouped.values())
    .map(zone => {
      const regularFreeSpaces = Math.max(zone.regular_spaces - zone.regular_busy_spaces, 0);
      const benefitFreeSpaces = Math.max(zone.benefit_spaces - zone.benefit_busy_spaces, 0);
      const totalSpaces = zone.regular_spaces + zone.benefit_spaces;
      const totalBusySpaces = zone.regular_busy_spaces + zone.benefit_busy_spaces;

      return {
        ...zone,
        regular_free_spaces: regularFreeSpaces,
        benefit_free_spaces: benefitFreeSpaces,
        total_spaces: totalSpaces,
        total_busy_spaces: totalBusySpaces,
        total_free_spaces: Math.max(totalSpaces - totalBusySpaces, 0),
      };
    })
    .sort((a, b) => Number(a.code) - Number(b.code));
};

export const makeParkingLotPatchPayload = (zoneId, maxParkingLots, occupiedLots) => {
  const payload = {
    max_parking_lots: toSafeInt(maxParkingLots),
    occupied_lots: toSafeInt(occupiedLots),
  };

  const parsedZoneId = Number(zoneId);
  if (Number.isFinite(parsedZoneId)) {
    payload.zone_id = parsedZoneId;
  }

  return payload;
};
